
<template>
  <v-card-text>
    <v-layout align-center row wrap>
      <v-flex
        class="periodLabel"
        xs12
        md6
        lg4
        py-4
        text-xs-center
        text-md-left
        text-lg-left
      >
        <slot name="label"></slot>
      </v-flex>
      <v-flex
        xs12
        md6
        lg4
        fill-height
        text-xs-center
        text-md-right
        text-lg-center
      >
        <v-btn
          :disabled="!headerProps.previousYear"
          class="previousYear"
          @click="onInput(headerProps.previousYear)"
          flat
          icon
        >
          <v-icon>mdi-chevron-double-left</v-icon>
        </v-btn>
        <v-btn
          :disabled="!headerProps.previousPeriod"
          class="previousPeriod"
          @click="onInput(headerProps.previousPeriod)"
          flat
          icon
        >
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-btn
          class="currentPeriod"
          @click="onInput(headerProps.currentPeriod)"
          flat
          icon
        >
          <v-icon>mdi-calendar-today</v-icon>
        </v-btn>
        <v-btn
          :disabled="!headerProps.nextPeriod"
          class="nextPeriod"
          @click="onInput(headerProps.nextPeriod)"
          flat
          icon
        >
          <v-icon>chevron_right</v-icon>
        </v-btn>
        <v-btn
          :disabled="!headerProps.nextYear"
          class="nextYear"
          @click="onInput(headerProps.nextYear)"
          flat
          icon
        >
          <v-icon>mdi-chevron-double-right</v-icon>
        </v-btn>
      </v-flex>
      <v-flex
        xs12
        lg4
        fill-height
        text-xs-center
        text-md-center
        text-lg-right
      >
        <slot name="displayPeriod"></slot>
      </v-flex>
    </v-layout>
  </v-card-text>
</template>
<script>
export default {
  name: 'CalendarViewHeader',
  props: {
    headerProps: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onInput(d) {
      this.$emit('input', d);
    },
  },
};
</script>
<style>

</style>
